import * as React from "react";
import Helmet from "react-helmet";
import { ThemeProvider } from "emotion-theming";
import "./index.css";
import { theme } from "../themes/global";

const DefaultLayout: React.FC = (props) => {
  React.useEffect(() => {
    var ua = window.navigator.userAgent;
    if (/Android/.test(ua) && /Linux; U;/.test(ua) && !/Chrome/.test(ua)) {
      alert("非対応ブラウザです");
    }
  }, []);
  return (
    <ThemeProvider theme={theme}>
      <div>
        <Helmet
          title="健康観察表"
          meta={[
            { name: "description", content: "健康管理表" },
            { name: "keywords", content: "岩崎学園, ISC, 健康" },
            { name: "twitter:card", content: "summary" },
            { property: "og:image", content: "../../images/iwasaki.svg" },
            { property: "og:title", content: "健康観察表" },
            {
              property: "og:description",
              content: "あなたの健康を管理しましょう",
            },
            {
              property: "og:url",
              content: `https://healthapp-iwasaki.netlify.com`,
            },
          ]}
        />
        {props.children}
      </div>
    </ThemeProvider>
  );
};

export default DefaultLayout;
